var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card card-alert",
      class: [_vm.readonly === true ? "readOnly" : "normalMode"],
    },
    [
      _c("div", { staticClass: "card-inner" }, [
        _c("div", { staticClass: "title-container" }, [
          _c("span", { staticClass: "icon" }, [_vm._t("icon")], 2),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [_vm._t("title")], 2),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-container" },
          [
            _vm._t("default"),
            _vm._v(" "),
            !!_vm.alerts
              ? _c(
                  "div",
                  [
                    _c("hr", { staticClass: "separator" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("profile.form.trigger"))),
                    ]),
                    _vm._v(" "),
                    !!_vm.alerts.sound
                      ? _c(
                          "b-form-checkbox",
                          {
                            staticClass: "switch-selecter sound-switch",
                            attrs: {
                              id: _vm.alertKey + "-sound-button",
                              checked:
                                this.alerts.sound.value == true ? true : false,
                              title: _vm.getTooltipForAlert(
                                _vm.alertKey,
                                "sound"
                              ),
                              disabled: _vm.readonly,
                              switch: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.toggleAlert("sound")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("profile.form.sound")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !!_vm.alerts.vibrator
                      ? _c(
                          "b-form-checkbox",
                          {
                            staticClass: "switch-selecter",
                            attrs: {
                              id: _vm.alertKey + "-vibrator-button",
                              checked:
                                this.alerts.vibrator.value == true
                                  ? true
                                  : false,
                              title: _vm.getTooltipForAlert(
                                _vm.alertKey,
                                "vibrator"
                              ),
                              disabled: _vm.readonly,
                              switch: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.toggleAlert("vibrator")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("profile.form.vibration")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !!_vm.alerts.flash
                      ? _c(
                          "b-form-checkbox",
                          {
                            staticClass: "switch-selecter flash-button",
                            attrs: {
                              id: _vm.alertKey + "-flash-button",
                              checked:
                                this.alerts.flash.value == true ? true : false,
                              title: _vm.getTooltipForAlert(
                                _vm.alertKey,
                                "flash"
                              ),
                              disabled: _vm.readonly,
                              switch: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.toggleAlert("flash")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("profile.form.flash")) +
                                "\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }